import { metaApiInstance, QUERY_KEY, type ServiceAppState, TOKEN_SCOPE } from '@kc-console/context';
import { getConsoleBaseUrl, STATUS_CODE } from '@kc-console/core';

import { getRequestUrlData } from '../../utils/getRequestUrlData';
import { getServerTraceHttpTimingOptions } from '../../utils/serverTrace/store';

import type { Guard } from '../../types/middlewares';

export const suggestRegionGuard: Guard<ServiceAppState> = async ({ context, state }) => {
  const { token, scope: targetScope, projectId: prevProjectId } = state;
  const { urlObj, region: queryRegion } = getRequestUrlData(context);

  if (targetScope === TOKEN_SCOPE.PROJECT) return { status: STATUS_CODE.OK };

  const isPrevTokenProjectScope = !!prevProjectId;

  if (!isPrevTokenProjectScope) {
    if (queryRegion) {
      urlObj.searchParams.delete(QUERY_KEY.REGION);
      return {
        redirect: {
          destination: `${getConsoleBaseUrl(urlObj.origin)}${urlObj.pathname}${urlObj.search}`,
          permanent: false,
        },
      };
    } else {
      return { status: STATUS_CODE.OK };
    }
  }

  const { fetchRecentRegion, fetchAccessibleRegion } = metaApiInstance({
    token,
    ...getServerTraceHttpTimingOptions(context.req, 'config'),
  });

  try {
    const recentRegions = await fetchRecentRegion();
    const accessibleRegions = await fetchAccessibleRegion();

    if (queryRegion) {
      if (accessibleRegions.includes(queryRegion)) {
        return { status: STATUS_CODE.OK, region: queryRegion };
      } else {
        urlObj.searchParams.delete(QUERY_KEY.REGION);
        return {
          redirect: {
            destination: `${getConsoleBaseUrl(urlObj.origin)}${urlObj.pathname}${urlObj.search}`,
            permanent: false,
          },
        };
      }
    }

    const suggestedRegion = accessibleRegions.includes(recentRegions[0])
      ? recentRegions[0]
      : accessibleRegions[0];

    if (suggestedRegion) {
      return { status: STATUS_CODE.OK, region: suggestedRegion };
    }

    return { status: STATUS_CODE.OK };
  } catch (error) {
    return { status: STATUS_CODE.OK };
  }
};

suggestRegionGuard.displayName = 'suggestRegionGuard';
